import React, { useEffect, useState } from "react";
import FileUpload from "../../Common/FileUpload";
import AnimatedDialog from "../../Common/AnimatedDialog";
import { isValidated } from "../../../utils";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AssetsIssuanceActions from "../../../store/actions/AssetsIssuance";
import * as UserActions from "../../../store/actions/User";
import Errors from "../../../constants/Errors.json";
import Button from "sushiweb/Button";
import ErrorMsgs from "../../../constants/Errors.json";

const ImageVerification = (props) => {
  const { disabled, completed, next, imageUpload, setStatus, driverDetails } =
    props;
  const [activeFileRiderPhoto, setActiveFileRiderPhoto] = useState("");
  const [activeFilePanPhoto, setActiveFilePanPhoto] = useState("");
  const [callback_key_pan_photo, setCallback_key_pan_photo] = useState("");
  const [callback_key_rider_photo, setCallback_key_rider_photo] = useState("");
  const [confirmPerson, setConfirmPerson] = useState(completed);
  const [successPanPhotoUpload, setSuccessPanPhotoUpload] = useState(false);
  const [successRiderPhotoUpload, setSuccessRiderPhotoUpload] = useState(false);
  const [presign_url_pan_photo, setPresign_url_pan_photo] = useState("");
  const [presign_url_rider_photo, setPresign_url_rider_photo] = useState("");
  const [inputDisabled, setInputDisabled] = useState(true);
  const [uploadingLoader, setUploadingLoader] = useState(false);
  useEffect(() => {
    setInputDisabled(completed || disabled);
  }, [completed, disabled]);

  const [inputError, setInputError] = useState("");

  const handleInputChange = (event) => {
    const value = event.target.checked;
    setConfirmPerson(value);
  };

  useEffect(() => {
    setSuccessPanPhotoUpload(false);
  }, [activeFilePanPhoto]);

  useEffect(() => {
    setSuccessRiderPhotoUpload(false);
  }, [activeFileRiderPhoto]);

  const handleUpload = () => {
    if (inputDisabled) {
      return;
    }
    if (!confirmPerson) {
      setInputError("You need to verify above or cancel");
      return;
    }
    let validatedState = isValidated({ pan_photo: activeFilePanPhoto }, [
      "pan_photo",
    ]);
    if (validatedState !== "validated") {
      setInputError(validatedState);
      return;
    }
    validatedState = isValidated({ rider_photo: activeFileRiderPhoto }, [
      "rider_photo",
    ]);
    if (validatedState !== "validated") {
      setInputError(validatedState);
      return;
    }
    if (validatedState === "validated") {
      setInputDisabled(true);
      setInputError("");
      setUploadingLoader(true);
      let payload = {
        file_category: "rider_photo",
        file_name: activeFileRiderPhoto.name,
        request_id: driverDetails.driver_id.toString(),
      };
      try {
        imageUpload(payload).then((res) => {
          if (res) {
            setCallback_key_rider_photo(res.callback_key);
            setPresign_url_rider_photo(res.file_upload_url);
          } else {
            throw "Rider photo not uploaded";
          }
          payload = {
            file_category: "pan_photo",
            file_name: activeFilePanPhoto.name,
            request_id: driverDetails.driver_id.toString(),
          };
          imageUpload(payload).then((res) => {
            if (res) {
              setCallback_key_pan_photo(res.callback_key);
              setPresign_url_pan_photo(res.file_upload_url);
            } else {
              throw "Pan photo not uploaded";
            }
          });
        });
      } catch (error) {
        setInputDisabled(false);
        setUploadingLoader(false);
        setStatus({
          type: "error",
          message:
            typeof error === "string" ? error : ErrorMsgs.GENERAL_ERROR_1,
        });
      }
    }
  };

  useEffect(() => {
    if (
      successPanPhotoUpload &&
      successRiderPhotoUpload &&
      !(completed || disabled)
    ) {
      setUploadingLoader(false);
      next();
    }
  }, [successPanPhotoUpload, successRiderPhotoUpload]);

  const handleClose = (type) => {
    if (type === "rider_photo") {
      setSuccessRiderPhotoUpload(true);
    } else {
      setSuccessPanPhotoUpload(true);
    }
  };
  const onError = (type, err) => {
    if (type === "rider_photo") {
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      });
    } else {
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      });
    }
    setInputDisabled(false);
    setUploadingLoader(false);
  };

  const InformationBar = () => {
    return (
      <div className={"mb-20"}>
        <p>Match PAN card and rider photo</p>
        <div class="col-xs-12 photo_match_div">
          <img src="/images/assets_issuance.png" alt="Match" />
        </div>
      </div>
    );
  };
  return (
    <div className={"flex flex-col h-full w-full justify-between text-center"}>
      <InformationBar />
      <div className={"mb-20"}>
        <FileUpload
          title={"Rider Image"}
          uploadUrl="/driver-assets/issuance/diy/verification/image"
          callback_key={callback_key_rider_photo}
          presign_url={presign_url_rider_photo}
          handleClose={() => {
            handleClose("rider_photo");
          }}
          onError={(err) => {
            onError("rider_photo", err);
          }}
          keyName="callback_key"
          activeFile={activeFileRiderPhoto}
          setActiveFile={setActiveFileRiderPhoto}
          disabled={inputDisabled}
          acceptTypes="image/*"
          maxSize={10}
        />
      </div>
      <div className={"mb-20"}>
        <FileUpload
          title={"Pan Card"}
          uploadUrl="/driver-assets/issuance/diy/verification/image"
          callback_key={callback_key_pan_photo}
          presign_url={presign_url_pan_photo}
          handleClose={() => {
            handleClose("pan_photo");
          }}
          keyName="callback_key"
          activeFile={activeFilePanPhoto}
          setActiveFile={setActiveFilePanPhoto}
          onError={(err) => {
            onError("pan_photo", err);
          }}
          disabled={inputDisabled}
          acceptTypes="image/*"
          maxSize={10}
        />
      </div>
      <label className={"mb-20"}>
        I confirm that PAN card photo and rider photo match.
        <input
          type="checkbox"
          checked={confirmPerson}
          onChange={handleInputChange}
          disabled={inputDisabled}
        />
      </label>
      {inputError && <div className="error-state">{"*" + inputError}</div>}
      <Button
        loading={uploadingLoader}
        className={"mb-20"}
        type="submit"
        onClick={handleUpload}
        disabled={disabled || completed}
      >
        Next
      </Button>
    </div>
  );
};

function mapStateToProps(state) {
  const { AssetsIssuance } = state;
  return {
    driverDetails: AssetsIssuance.driverDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    imageUpload: bindActionCreators(
      AssetsIssuanceActions.imageUpload,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageVerification);
